// Типы для использования в аттрибуте "accept" тега <input type="file" />
export const uploadFileTypes = {
  txt: ".txt",
  csv: ".csv",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
} as const;
